import React, { Component } from 'react';
import { connect } from 'react-redux';

import { authSuccess, getUserDetails } from '../../../store/actions/auth';
import { Companyid, QR_GUEST_EMP_ID, QR_GUEST_USER_ID } from '../../../shared/Config';

// Replaces CustomerLogin for /pos/qrorder* routes — bootstraps a shared,
// hardcoded "QR Guest" identity instead of asking the customer to sign in.
// Writes the same localStorage keys a real login (auth.js's auth()) writes,
// then reuses the existing authSuccess/getUserDetails action creators to
// populate redux state exactly like a real login would — no new redux file.
// See src/shared/Config.js for the QR_GUEST_EMP_ID/QR_GUEST_USER_ID setup
// step this depends on.
//
// Renders a loader for one frame regardless, so bootstrap (when needed)
// finishes — and the redux dispatch inside it resolves synchronously — before
// props.children ever mounts. React fires componentDidMount bottom-up, so if
// children rendered on the very first pass they'd read loggedUserDetail
// before this component had a chance to populate it.
class QrGuestGate extends Component {

    state = { ready: false };

    componentDidMount() {
        // Already has a real identity — either a returning guest session, or
        // (if a staff member landed directly on a QR link) their own real
        // login. Either way, don't clobber it.
        if (!localStorage.getItem('EmpId')) {
            this.bootstrapGuestSession();
        }
        this.setState({ ready: true });
    }

    bootstrapGuestSession = () => {
        const token = 'qr-guest-token';
        // Deliberately no checkAuthTimeout dispatch — a guest session isn't
        // meant to auto-logout, unlike a staff session.
        const expirationDate = new Date(new Date().getTime() + 10 * 365 * 24 * 60 * 60 * 1000);

        localStorage.setItem('token', token);
        localStorage.setItem('expirationDate', expirationDate);
        localStorage.setItem('EmpId', QR_GUEST_EMP_ID);
        localStorage.setItem('userId', QR_GUEST_USER_ID);
        localStorage.setItem('userID', QR_GUEST_USER_ID);
        localStorage.setItem('CompanyId', Companyid);
        localStorage.setItem('defaultbranch', '00000000-0000-0000-0000-000000000001');
        localStorage.setItem('firstTimeLogin', 'false');
        localStorage.setItem('hrTeam', '0');
        localStorage.setItem('admin', '0');
        localStorage.setItem('isEditingWca', 'false');
        localStorage.setItem('autoRefresh', 'false');

        this.props.dispatch(authSuccess(token, QR_GUEST_EMP_ID));
        this.props.dispatch(getUserDetails(QR_GUEST_USER_ID));
    };

    render() {
        if (!this.state.ready) {
            return <div className="page-loader" />;
        }
        return this.props.children;
    }
}

export default connect()(QrGuestGate);
